export enum SessionSetting {
  SidenavExpanded = 'field-view.sidenav-expanded',
}
